import { render } from "./CustomerSizeProfile.vue?vue&type=template&id=43aa997f&scoped=true"
import script from "./CustomerSizeProfile.vue?vue&type=script&lang=js"
export * from "./CustomerSizeProfile.vue?vue&type=script&lang=js"

import "./CustomerSizeProfile.vue?vue&type=style&index=0&id=43aa997f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43aa997f"]])

export default __exports__